<template>
  <v-container>
    <v-row>
      <v-col cols="12">

        <v-card width="100%" height="100%">
          
          <v-card-title primary-title>
            Análisis por persona
            <v-spacer></v-spacer>
            <!-- EXCEL -->
            <v-col cols="2">
              <v-btn align="right" small color="green" dark>
              <download-excel
                :data="plantas"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="GraXPersona.xls"
              >
                Excel
                <v-icon class="ma-1">mdi-download</v-icon>
              </download-excel>
              </v-btn>
            </v-col>

          </v-card-title>

        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="3">
            <v-text-field
              class="ma-2"
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="ma-2"
                  v-model="fecha1"
                  label="Fecha Inicial"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
                <v-date-picker
                  v-model="fecha1"
                  @input="menu1 = false"
                ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="ma-2"
                  v-model="fecha2"
                  label="Fecha Final"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
                <v-date-picker
                  v-model="fecha2"
                  @input="menu2 = false"
                ></v-date-picker>
            </v-menu>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="2">
            <v-btn
              @click ="consultar"
              color="info"
              small
              class="ma-2"
              >Consultar
            </v-btn>
          </v-col>
        </v-row>

            <v-card-text>

              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="plantas"
                class="elevation-1"
                fixed-header
                height="450"
                hide-default-footer
                loading-text="Cargando..."
                dense
                :search="search"
                :items-per-page=200
                calculate-widths
                >

              <template v-slot:item="{ item }" >
               <tr v-on:dblclick.prevent.stop="edit(item)">
                  <td>{{ item.nomina }}</td>
                  <td>{{ item.nomuser }}</td>
                  <td>{{ item.nomplanta }}</td>
                  <td>{{ item.codplanta }}</td>
                  <td>{{ item.nomarea }}</td>
                  <td>{{ item.cant }}</td>

                   <!-- <v-chip small
                    :color="getColor(item.estatus)"
                    dark class="align-end"
                    >
                    {{ item.estatus }}
                  </v-chip> -->
               </tr>
             </template>
             

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {

  data: () => ({
    dialog: false,
    headers: [
      { text: 'Nomina', align: 'left',sortable: false, value: 'nomina' },
      { text: 'Nombre de la persona'   , value: 'nomuser' },
      { text: 'Planta'              , value: 'nomplanta' },
      { text: 'Planta'              , value: 'codplanta' },
      { text: 'Area'                , value: 'nomarea' },
      { text: 'Cantidad'               , value: 'cant' },
      // { text: 'Estatus'     , value: 'estatus', align:'start'},
    ],
    plantas: [],
    search: '',

		  fecha1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
		  fecha2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu1: false,
    menu2: false,

    loading: false,
    json_fields: {
      Nomina: "nomina",
      Nombre: "nomuser",
      Planta: "nomplanta",
      CodigoPlanta: "codplanta",
      Area: "nomarea",
      Cantidad: "cant",
    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    json_data: [],
           
  }),

  created () {
    // this.init()
    // Definir valores iniciales
    // Fecha inicial Primero de mes.
    let date0 = new Date()
    let mes = date0.getMonth()
    let anio = date0.getFullYear()
            
    // console.log(mes, anio)
    this.fecha1 = new Date(anio, mes, 1).toISOString().substr(0, 10)
    this.consultar()
  },

  methods: {

    getColor (estatus) {
      if (estatus > 1) return 'green'
      else if (estatus > 2) return 'orange'
      else return 'red'
    },

    edit(planta){
      // this.$router.push({name:'newplanta',
      //    params: planta
      // })
    },

    consultar () {
      //Consultar Usuarios
      this.loading = true

      let payload = {
        fecha1: this.fecha1,
        fecha2: this.fecha2,
      }
        
      this.$http.post('v2/graxpersona.filtro', payload).then( response => {
        // console.log('response',response)
        if (response.data.result != null){
          this.plantas = response.data.result
        }

      }).catch(error => {
        console.log(error)
      }).finally(()  => this.loading = false)
    
    }
  }
}
</script>